module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "empty",
    on: {
      "click": _vm.emptyData
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.buttonType.msg[0]))])]), _vm._v(" "), (_vm.buttonType.msg.length > 1) ? _c('button', {
    staticClass: "added",
    on: {
      "click": _vm.addData
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-save"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.buttonType.msg[1]))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0931dbec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/ButtonGroup.vue
// module id = 194
// module chunks = 1